import { render } from "./CGridRadioColumn.vue?vue&type=template&id=00990b67&scoped=true"
import script from "./CGridRadioColumn.vue?vue&type=script&lang=js"
export * from "./CGridRadioColumn.vue?vue&type=script&lang=js"

import "./CGridRadioColumn.vue?vue&type=style&index=0&id=00990b67&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00990b67"]])

export default __exports__